<template>
  <div>
    <vetster-slide-over-common-heading
      :header="$t('app.about')"
      :show-close="false"
      show-back
      is-simple-heading
      class="sticky pt-4 -top-1 bg-white"
      @back="$emit('previous', $event)"
    />
    <div class="mt-3 space-y-5 px-standard">
      <p
        v-for="(paragraph, index) in paragraphs"
        :key="`px-description-paragraph-${index}`"
      >
        {{ paragraph }}
      </p>
    </div>
  </div>
</template>

<script>
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';

export default {
  name: 'VetsterPartnerDetailsAbout',

  components: { VetsterSlideOverCommonHeading },

  props: {
    description: {
      type: String,
      required: true,
    },
  },

  computed: {
    paragraphs() {
      if (!this.description) {
        return [];
      }

      return this.description.match(/[^\r\n]+/g);
    },
  },
};
</script>
